module.exports = __webpack_public_path__ + "static/media/new24.cff9546b.jpg";